import React, { useEffect, useState } from 'react'
import './style.scss'
import { useNavigate, useParams } from 'react-router-dom'
import { slUv1Axios } from '../../../config/axios'
import { mergeTwoArrayByKey } from '../../../assets/javascript/function-helper'
import Modal from '../../../components/common/modal/Modal'
import CalendarComp from '../../calendar/CalendarComp'
import SingleButton from '../../../components/common/buttons/SingleButton'
import { BsFilter } from 'react-icons/bs'
import InstallationCalenderFilter from '../../../components/installation/calender-filter/InstallationCalenderFilter'


const InstallationCalendar = ({ setPageHead }) => {
    const { view, theYear, theMonth, theDate } = useParams()
    const [date, setDate] = useState(new Date(theYear, Number(theMonth) - 1, theDate))
    const [events, setEvents] = useState([])
    const [cache, setCache] = useState([])
    const [filterData, setFilterData] = useState([1, 2, 3])
    const [modal, setModal] = useState({ status: false })
    const navigate = useNavigate()



    const fetchEvents = (fromDate, endDate) => {

        slUv1Axios.get(`/installation/bucket/calender-event?fromDate=${new Date(fromDate).toISOString()}&endDate=${new Date(endDate).toISOString()}`).then((response) => {

            const formattedEvents = response.data.map(event => ({
                ...event,
                start: event?.installation_status === 3 ? new Date(event.start) : new Date(new Date(event.start).setHours(0, 0, 0, 0)), // Ensure start is a Date object
                end: event?.installation_status === 3 ? new Date(event.end) : new Date(new Date(event.end).setHours(24, 0, 0, 0))    // Ensure end is a Date object
            }));
            setCache((state) => {
                return mergeTwoArrayByKey(state, formattedEvents, 'installation_id')
            });
        })
    }

    const handleNavigateCalender = (navigateDate) => {
        // URL update
        navigate(`/installation/calendar/${view}/${navigateDate.getFullYear()}/${navigateDate.getMonth() + 1}/${navigateDate.getDate()}?page=calendar`)

        // Fetch data
        const currentDate = date

        const FPM = new Date(new Date(navigateDate).getFullYear(), new Date(navigateDate).getMonth() - 1, 1)
        const LPM = new Date(new Date(navigateDate).getFullYear(), new Date(navigateDate).getMonth(), 1)
        const FNM = new Date(new Date(navigateDate).getFullYear(), new Date(navigateDate).getMonth() + 1, 1)
        const LNM = new Date(new Date(navigateDate).getFullYear(), new Date(navigateDate).getMonth() + 2, 1)

        setDate(new Date(navigateDate))

        const params = currentDate < new Date(navigateDate) ? [FNM, LNM] : [FPM, LPM]
        const filterData = events.filter((a) => params[0] <= new Date(a.start) && params[1] > new Date(a.start))

        if (new Date(navigateDate).getFullYear() === currentDate.getFullYear() &&
            new Date(navigateDate).getMonth() === currentDate.getMonth()) {
            return
        }

        if (filterData?.[0]) {
            return
        }

        fetchEvents(params[0], params[1])
    }

    const handleClickEvent = (eventData) => {
        navigate(`/installation/bucket-list/${eventData?.prospect_id}/${eventData?.installation_id}`)
    }

    const handleViewChangeFn = (viewType) => {
        navigate(`/installation/calendar/${viewType}/${theYear}/${theMonth}/${theDate}?page=calendar`)
    }

    useEffect(() => {
        if (filterData?.length > 0) {
            setEvents(cache.filter((item) => filterData?.includes(item.installation_status)))
        } else {
            setEvents(cache)
        }
    }, [cache, filterData])


    useEffect(() => {
        setPageHead({})

        // Fetch default data
        const firstDayPreviousMonth = new Date(new Date(date).getFullYear(), new Date(date).getMonth() - 1, 1);
        const lastDayNextMonth = new Date(new Date(date).getFullYear(), new Date(date).getMonth() + 2, 1);

        fetchEvents(firstDayPreviousMonth, lastDayNextMonth)
        // eslint-disable-next-line
    }, [])


    return (
        <div className="installation-calendar-page-div">
            <Modal modal={modal} setModal={setModal} />
            <CalendarComp
                defaultDate={date}
                events={events}
                defaultView={view}
                handleNavigate={handleNavigateCalender}
                handleSelectEvent={handleClickEvent}
                handleViewChange={handleViewChangeFn}
            />

            <div className="app-icon-div">
                <SingleButton title={'Select date'} stIcon={<BsFilter />} classNames={'icon-only btn-primary'}
                    style={{ padding: '13px', fontSize: '31px', borderRadius: '100px' }}
                    onClick={() => setModal({
                        status: true, title: 'Filter Calendar',
                        content: <InstallationCalenderFilter data={filterData} setData={setFilterData} />
                    })} />
            </div>
        </div>
    )
}

export default InstallationCalendar